<template>
  <div class="inner_content">
    <div class="header">
      <!-- <div class="flex">
        <div class="box flex" style="align-items=center">
          <el-input placeholder="请选择手机号或名称" size="small"></el-input>
          <el-button type="primary" size="small" @click="getLists"
            >筛选</el-button
          >
        </div>
        <div class="paddingLeft">
          <el-button type="primary" size="small" @click="editButton"
            >添加分组</el-button
          >
        </div>
      </div> -->
      <el-button type="primary" size="small" @click="editButton(0)"
        >添加分组</el-button
      >
    </div>
    <div class="bottom">
      <el-table
        :data="listData"
        size="small"
        :header-cell-style="setHeader"
        height="100%"
      >
        <!--  -->
        <el-table-column label="分组名称" prop="name"></el-table-column>
        <el-table-column label="分组下的车队列表" prop="name">
          <template slot-scope="scope">
            <el-button
              type="text"
              slot="reference"
              @click="rowClick(scope.row.id)"
              >点击查看</el-button
            >
          </template>
        </el-table-column>
        <el-table-column width="165px" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              slot="reference"
              @click="editButton(scope.row.id)"
              >编辑</el-button
            >
            <el-button
              type="text"
              slot="reference"
              @click="option(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, prev, pager, next, jumper"
        :total="total_num"
      >
      </el-pagination>
    </div>
    <!-- 编辑分组 -->
    <el-dialog
      width="30%"
      :title="editMessage.title"
      :visible.sync="innerVisible"
      append-to-body
    >
      <el-form label-width="100px">
        <el-form-item label="分组名称">
          <el-input size="small" v-model="editMessage.name"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="(innerVisible = false), (editMessage.name = '')"
          >取 消</el-button
        >
        <el-button type="primary" @click="editGroupName">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 分组下的车队列表 -->
    <el-dialog title="车队列表" :visible.sync="dialogTableVisible">
      <el-table :data="cardData" height="450">
        <el-table-column label="公司名称" prop="name"></el-table-column>
        <el-table-column label="电话" prop="mobile"></el-table-column>
        <el-table-column
          label="预估金额"
          prop="estimated_amount"
        ></el-table-column>
        <el-table-column label="余额" prop="collect.balance"></el-table-column>
        <el-table-column
          label="消费"
          prop="collect.consume_amount"
        ></el-table-column>
        <el-table-column label="开户时间" prop="create_time"></el-table-column>
      </el-table>
      <!-- 分页按钮 -->
      <div class="Otherpage">
        <el-pagination
          layout="prev, pager, next, total, jumper"
          :current-page="cartPage"
          :total="cartTotal"
          :page-size="10"
          @current-change="PageHandleCurrentChange"
        >
          <!--  -->
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import {
  groupList,
  groupDetail,
  groupEdit,
  groupDel,
  groupAdd,
  List
} from "@/api/motorcade";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  inject: ["reload"],
  data() {
    return {
      cartTotal: 0,
      cartPage: 0,
      optionStatus: false, //false 为添加，true编辑
      groupName: "",
      page: "1",
      total_num: 0,
      listData: [],
      cardData: [],
      dialogFormVisible: false,
      innerVisible: false,
      dialogTableVisible: false,
      value1: "",
      value: "",
      headerStyle: {
        background: "rgba(250,250,250,1)",
        color: "#000000"
      },
      editMessage: {
        title: "",
        id: "",
        name: ""
      }
    };
  },
  mounted() {
    this.getLists();
  },
  methods: {
    // 行点击展示该分组下的列表
    rowClick(row) {
      console.log("行信息", row);
      this.dialogTableVisible = true;
      this.getList(row);
    },
    // 设置表头颜色
    setHeader({ rowIndex }) {
      if (rowIndex === 0) {
        return this.headerStyle;
      } else {
        return "";
      }
    },
    option(Oid) {
      let data = {
        token: this.token,
        app_id: this.app_id,
        id: Oid
      };
      this.$confirm("确定要删除该分组吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          groupDel(data).then(res => {
            if (res.code == 200) {
              this.$message.success("删除成功！！");
              this.reload();
            } else {
              this.$message.warning(res.msg);
            }
          });
        })
        .catch();
    },
    editButton(id = 0) {
      if (id == 0) {
        this.editMessage.title = "添加分组";
        this.optionStatus = false;
      } else {
        (this.optionStatus = true), (this.editMessage.title = "编辑分组");
        this.editMessage.id = id;
        let data = {
          app_id: this.app_id,
          token: this.token,
          id: id
        };
        groupDetail(data).then(res => {
          console.log("详情", res);
          if (res.code == 200) {
            this.editMessage.name = res.data.name;
          }
        });
      }
      this.innerVisible = true;
    },
    editGroupName() {
      if (this.editMessage.name == "") {
        this.$message.warning("请填写分组名称！！");
        return;
      }
      let data = {
        token: this.token,
        app_id: this.app_id,

        name: this.editMessage.name
      };
      // true 编辑

      if (this.optionStatus) {
        this.$confirm("确定要编辑该分组吗？", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            (data.id = this.editMessage.id),
              groupEdit(data).then(res => {
                if (res.code == 200) {
                  this.innerVisible = false;
                  this.editMessage = {};
                  this.$message.success("编辑成功");
                  this.reload();
                } else {
                  this.$message.warning(res.msg);
                }
              });
          })
          .catch(() => {
            this.editMessage.name = "";
          });
      } else {
        this.$confirm("确定要添加该分组吗？", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            groupAdd(data).then(res => {
              if (res.code == 200) {
                this.innerVisible = false;
                this.editMessage = {};
                this.$message.success("添加成功");
                this.reload();
              } else {
                this.$message.warning(res.msg);
              }
            });
          })
          .catch(() => {
            this.editMessage.name = "";
          });
      }
    },
    //分组列表
    getLists() {
      let data = {
        token: this.token,
        app_id: this.app_id,
        page: this.page,
        is_auth: 0
      };
      groupList(data).then(res => {
        if (res.code == 200) {
          this.listData = res.result;
          this.total_num = res.total_num;
        } else {
          this.$message.warning(res.msg);
        }
        console.log("列表", res);
      });
    },
    // 车队列表
    getList(c_id) {
      var data = {
        token: this.token,
        app_id: this.app_id,
        page: this.cartPage,
        group_id: c_id
      };
      List(data).then(res => {
        if (res.code == 200) {
          this.cardData = res.result;
          this.cartTotal = res.total_num;
          for (var i = 0; i < this.cardData.length; i++) {
            switch (this.cardData[i].is_auth) {
              case 0:
                this.cardData[i].auth = "待审核";
                break;
              case 1:
                this.cardData[i].auth = "审核不通过";
                break;
              case 2:
                this.cardData[i].auth = "通过";
                break;
            }
          }
        } else {
          this.$message.warning(res.msg);
        }
        console.log("列表", res);
      });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getLists();
    },
    // 車隊列表分頁
    PageHandleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.cartPage = val;
      this.getList();
    }
  }
};
</script>
<style lang="scss" scoped>
.inner_content {
  height: 100%;
  background: #fff;
  padding: 0 24px;
  display: flex;
  flex-direction: column;
  font-size: 14px;
  .header {
    padding-top: 20px;
    margin-bottom: 20px;
    .box {
      width: 330px;
      .title {
        min-width: 50px;
        text-align: right;
      }
      .fixedwidth {
        width: 180px;
        display: flex;
        justify-content: space-between;
      }
    }
    .paddingLeft {
      padding-left: 20px;
    }
  }
  .bottom {
    flex: 1;
    overflow-y: scroll;
  }
  .page {
    height: 50px;
    display: flex;
    align-items: center;
  }
}
// 通用样式
.flex {
  display: flex;
  align-items: center;
  padding: 10px 0px;
}
// .table_height {
//   height: 100px;
//   overflow: auto;
// }
</style>
